import { render, staticRenderFns } from "./agreement-on-sms-fees.vue?vue&type=template&id=0237c466"
import script from "./agreement-on-sms-fees.vue?vue&type=script&lang=js"
export * from "./agreement-on-sms-fees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports